// extracted by mini-css-extract-plugin
export var locationCard = "_cz-0";